import {Card, CardActionArea, CardContent, Checkbox, Grid, Typography} from "@mui/material"
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";


export type SelectableCardProps = {
    title?: any
    selected?: boolean
    children?: any
    onClick?: () => void
}


const useStyles = makeStyles<PortTheme, SelectableCardProps>(theme => ({
    root: {
        width: "100%",
        border: props => props.selected ? "solid 1px #009ACF" : "solid 1px white",
    },
}))


export const SelectableCard = React.memo<SelectableCardProps>((props) => {
    const classes = useStyles(props);
    const {title, selected, children, onClick} = props;

    const handleClick = (e) => {
        e.stopPropagation();
        onClick && onClick();
    }

    return (
        <Card className={classes.root}>
            <CardActionArea>
                <CardContent onClick={handleClick}>
                    <Grid container direction="column" rowSpacing="10px" wrap="nowrap">
                        <Grid item container justifyContent="space-between"
                              alignItems="flex-start"
                              wrap="nowrap">
                            <Grid item>
                                <Typography variant="cardTitle1" display="block" component="div">
                                    {title}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Checkbox
                                    edge="end"
                                    color="additionalPrimary"
                                    checked={selected}
                                    onClick={e => null}
                                    style={{paddingTop: 0}}
                                />
                            </Grid>
                        </Grid>
                        {React.Children.map(children, (child, index) => (
                            <Grid item key={index}>
                                {child}
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    )
});